import "./_search-input.scss";

import {ReactComponent as SearchIcon} from "../../core/ui/icon/Search.svg";

import {TypeaheadInput} from "@hipo/react-ui-toolkit";
import {TypeaheadInputProps} from "@hipo/react-ui-toolkit/dist/form/input/typeahead/TypeaheadInput";
import classNames from "classnames";
import {forwardRef} from "react";

const SearchInput = forwardRef<HTMLInputElement, TypeaheadInputProps>(
  ({customClassName, children, leftIcon = <SearchIcon />, ...otherProps}, ref) => {
    return (
      <TypeaheadInput
        ref={ref}
        leftIcon={leftIcon}
        customClassName={classNames(customClassName, "search-input")}
        {...otherProps}>
        {children}
      </TypeaheadInput>
    );
  }
);

export default SearchInput;
